import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getFeaturedPortfolio } from "../../config/portfolioData";
import { useLanguage } from "../../context/LanguageContext";
import PortfolioCard from "./PortfolioCard";

function PortfolioSection() {
  const { t } = useLanguage();
  const items = getFeaturedPortfolio(6);

  return (
    <Container fluid className="broxe-section broxe-portfolio-preview" id="portfolio-preview">
      <Container>
        <Row className="mb-4 text-center">
          <Col lg={8} className="mx-auto">
            <h2 className="broxe-section-title">{t("portfolio.sectionTitle")}</h2>
            <p className="text-white-50 mb-0">{t("portfolio.sectionSubtitle")}</p>
          </Col>
        </Row>
        <Row className="g-4">
          {items.map((project) => (
            <Col key={project.id} md={6} xl={4}>
              <PortfolioCard project={project} compact />
            </Col>
          ))}
        </Row>
        <Row className="mt-4 justify-content-center">
          <Col className="col-12 col-sm-auto text-center">
            <Button variant="outline-light" className="w-100 w-sm-auto px-4" as={Link} to="/portfolio">
              {t("portfolio.viewAll")}
            </Button>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default PortfolioSection;
